import Illustrate from '@/components/Illustrate'
import RewardRule from '@/components/RewardRule'
import useLiveInfo from '@/hooks/useLiveInfo'
import styles from './index.module.sass'

export default function Notice ({ shop }) {
  const { serviceId } = useLiveInfo()

  const rewardInfo = !serviceId || serviceId === 'MYSHOP'
    ? <></>
    : <>
        <RewardRule url={shop?.benefitLandingUrl} />
        <div className={styles.space}/>
      </>

  return (
    <div>
      {rewardInfo}
      <Illustrate />
    </div>
  )
}
